import { forwardRef, type Ref, type SVGProps } from "react";
const IconMinusCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m7 15H9a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMinusCircleFilledSVG);
ForwardRef.displayName = "IconMinusCircleFilled";
export { ForwardRef as IconMinusCircleFilled };
